import Header from "../blocks/header";
import Dashboard from "../blocks/dashboard";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import Copyright from "../blocks/copyright";
import Box from "@mui/material/Box";
import {useNavigate, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {connect} from "react-redux";
import {getAllVerifyResponse} from "../store/logIn";
import Button from "@mui/material/Button";
import {toast} from "react-toastify";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import {saveSectionReport, messageReset} from "../store/sectionReports";
import {TextareaAutosize} from "@mui/material";

const SECTION_LABELS = {
    biznes_reja: 'section_biznes_reja',
    kuzgi_qishki: 'section_kuzgi_qishki',
    mehnat_muhofazasi: 'section_mehnat_muhofazasi',
    yongin_xavfsizligi: 'section_yongin_xavfsizligi',
    inventarizatsiya: 'section_inventarizatsiya',
}

function SectionAdd(props) {
    const navigate = useNavigate()
    const {t} = useTranslation()
    const params = useParams()
    const sectionType = params.sectionType
    const pageTitle = t(SECTION_LABELS[sectionType] || sectionType)

    const [file, setFile] = useState('')
    const [fileName, setFileName] = useState('')
    const [text, setText] = useState('')

    const toBack = () => navigate(-1)

    function prepareUpload(event) {
        const f = event.target.files[0]
        if (f) {
            setFile(f)
            setFileName(f.name)
        }
    }

    function saveFormData(e) {
        e.preventDefault()
        if (!file) {
            setFileName('*')
            return
        }
        const data = {
            section_type: sectionType,
            file: file,
            text: text,
        }
        props.saveSectionReport(data)
    }

    useEffect(() => {
        if (props.message === true) {
            setFile('')
            setFileName('')
            setText('')
            toast.success(t('save_success'), {theme: 'colored'})
            navigate(`/sections/${sectionType}/`)
        } else if (props.message === 'error') {
            toast.error(t('save_error'), {theme: 'colored'})
            props.messageReset()
        }
    }, [props.message])

    return <div>
        <div className={'page'}>
            <Header/>
            <Dashboard/>
            <Box component="main" sx={{flexGrow: 1, height: '100vh', overflow: 'auto'}}>
                <Toolbar/>
                <div className={'main'}>
                    <Button variant="outlined" startIcon={<ChevronLeftIcon/>} onClick={toBack}>
                        {t('back')}
                    </Button>
                    <h2 className={'page-title text-center'}>{pageTitle}</h2>
                    <form className={'add-form add-document'} onSubmit={saveFormData} encType={'multipart/form-data'}>

                        {/* Fayl yuklash - majburiy */}
                        <p>
                            <span className={fileName === '*' ? 'text-danger' : ''}>
                                {t('take_file')}: {fileName === '*' ? t('section_file_required') : fileName}
                            </span>
                            <Button className={'file-upload-btn'} variant="contained" component="label">
                                {t('take_file')}
                                <input name={'section_file'} hidden type="file"
                                       onChange={prepareUpload} title={t('take_file')}/>
                            </Button>
                        </p>

                        {/* Qo'shimcha matn - ixtiyoriy */}
                        <p>
                            <span>{t('section_text_label')}:</span>
                            <TextareaAutosize
                                minRows={5}
                                placeholder={t('section_text_placeholder')}
                                value={text}
                                onChange={(e) => setText(e.target.value)}
                                style={{
                                    padding: '16px 14px',
                                    borderRadius: '4px',
                                    border: '1px solid #ccc',
                                    fontSize: '16px',
                                    fontFamily: 'inherit',
                                    resize: 'vertical',
                                }}
                            />
                        </p>

                        <Button type={'submit'} style={{width: '100%'}} variant="contained"
                                fullWidth color={'info'}>
                            {t('save')}
                        </Button>
                    </form>
                </div>
                <Copyright/>
            </Box>
        </div>
    </div>
}

export default connect(props => props.sectionReport, {
    saveSectionReport,
    getAllVerifyResponse,
    messageReset,
})(SectionAdd)